import { PushOrdersContainer } from '@/modules/PushOrders';

export const PushOrders = (): JSX.Element => <PushOrdersContainer />;

export default PushOrders;
